import { firebaseApp } from './app'
import 'firebase/auth'

export const auth = firebaseApp.auth();